import { render, staticRenderFns } from "./SurveyNotice.vue?vue&type=template&id=2d921698"
import script from "./SurveyNotice.vue?vue&type=script&lang=js"
export * from "./SurveyNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports